import { useAuthorizedQuery } from "../api/authorized-query";
import { seedgreenAPI } from "../api/axios";
import { RanchDTO } from "../dtos/RanchDTO";
import { STALE_TIME_MEDIUM } from "../queries/query.constants";
import { useQuery, useQueryClient, useMutation } from "@tanstack/vue-query";
import _ from "lodash";
import { computed } from "vue";
const RANCH_STALE_TIME = STALE_TIME_MEDIUM; // 5 minutes
export function useRanches() {
    const query = useQuery({
        enabled: useAuthorizedQuery(),
        queryKey: ["ranch"],
        queryFn: async () => (await seedgreenAPI.get("/v2/Ranch")).data,
        staleTime: RANCH_STALE_TIME,
        select: (data) => {
            try {
                return data?.map((ranch) => new RanchDTO(ranch)) ?? [];
            }
            catch (error) {
                console.error("query/ranch::select ERROR", error);
            }
        },
    });
    return {
        ranches: query.data,
        ranchesById: computed(() => _.keyBy(query.data.value ?? [], "id")),
        ...query,
    };
}
/**
 * Mutation to create a new ranch
 * Returns the ID of the newly created ranch
 */
export function useCreateRanch() {
    const queryClient = useQueryClient();
    const isAuthorized = useAuthorizedQuery();
    const { mutateAsync, isPending, error } = useMutation({
        mutationFn: async (data) => {
            if (!isAuthorized.value)
                throw new Error("Not authorized");
            const response = await seedgreenAPI.post("/v2/Ranch", data);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["ranch"] });
        },
    });
    return {
        createRanch: mutateAsync,
        isPending,
        error,
    };
}
/**
 * Mutation to update an existing ranch
 */
export function useUpdateRanch() {
    const queryClient = useQueryClient();
    const isAuthorized = useAuthorizedQuery();
    const { mutateAsync, isPending, error } = useMutation({
        mutationFn: async ({ id, data, }) => {
            if (!isAuthorized.value)
                throw new Error("Not authorized");
            await seedgreenAPI.put(`/v2/Ranch/${id}`, data);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["ranch"] });
        },
    });
    return {
        updateRanch: mutateAsync,
        isPending,
        error,
    };
}
